export enum PossibleTitles {
    DEFAULT = 'Halo Doctor',
}
